export const getAddressLines = (place: google.maps.places.PlaceResult) => {
	// Anything from the first element to `locality` is address line 1.
	// `locality` is address line 2, which is usually the suburb.
	// If we can't find `locality` then no line 1 or 2
	const addressLine1Components: string[] = [];
	for (const component of place.address_components ?? []) {
		if (component.types.includes('locality')) {
			return {
				addressLine1: addressLine1Components.join(' '),
				addressLine2: component.long_name,
			};
		}
		addressLine1Components.push(component.long_name);
	}

	return {
		addressLine1: '',
		addressLine2: '',
	};
};
